import { ChevronDown, Download, FileText, History, Loader2 } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { useDescargarRetroPdf } from "@/hooks/reportes/useDescargarRetroPdf";
import { cn } from "@/lib/utils";
import { accionSecundaria } from "./estilos";

type Props = {
  idActividadAprendiz?: number;
  actividadNombre: string;
  disabled: boolean;
  className?: string;
  /** Acción extra al final del menú (p. ej. descargar el reto original). */
  onDescargarReto?: () => void;
};

/** Menú para descargar en PDF la retro actual o el historial de la actividad. */
export function DescargarRetroMenu({
  idActividadAprendiz,
  actividadNombre,
  disabled,
  className,
  onDescargarReto,
}: Props) {
  const { mutate: descargar, isPending } = useDescargarRetroPdf();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className={cn(accionSecundaria, className)}
          disabled={disabled || isPending || !idActividadAprendiz}
        >
          {isPending ? (
            <>
              <Loader2 className="h-4 w-4 flex-shrink-0 animate-spin" />
              Generando PDF...
            </>
          ) : (
            <>
              <Download className="h-4 w-4 flex-shrink-0" />
              Descargar
              <ChevronDown className="h-4 w-4 flex-shrink-0 opacity-60" />
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuItem
          onClick={() =>
            idActividadAprendiz &&
            descargar({ idActividadAprendiz, alcance: "ultimo", actividadNombre })
          }
          className="flex items-start gap-2 py-2"
        >
          <FileText className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <span className="flex flex-col">
            <span>Esta retroalimentación</span>
            <span className="text-xs opacity-60">PDF de tu intento más reciente</span>
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() =>
            idActividadAprendiz &&
            descargar({ idActividadAprendiz, alcance: "historial", actividadNombre })
          }
          className="flex items-start gap-2 py-2"
        >
          <History className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <span className="flex flex-col">
            <span>Historial completo</span>
            <span className="text-xs opacity-60">
              Todos tus intentos y la conversación con el coach
            </span>
          </span>
        </DropdownMenuItem>
        {onDescargarReto && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={onDescargarReto}
              className="flex items-start gap-2 py-2"
            >
              <Download className="mt-0.5 h-4 w-4 flex-shrink-0" />
              <span className="flex flex-col">
                <span>Descargar reto</span>
                <span className="text-xs opacity-60">Archivo original de la actividad</span>
              </span>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
